import { Font } from '@react-pdf/renderer'

// react-pdf only breaks lines at spaces/hyphens, so a long unbroken reference such as
// "5927L6700C=YY202606220508" runs past the cell edge and is cut off on the printed page.
// This lets such tokens break (in 12-character pieces) ONLY when they are long; ordinary words
// are left whole. Global to react-pdf, so every note/invoice PDF benefits. Safe to call repeatedly.
let registered = false
export function registerPdfLongWordBreaking(): void {
  if (registered) return
  registered = true
  Font.registerHyphenationCallback(word =>
    word.length <= 16 ? [word] : (word.match(/.{1,12}/g) ?? [word]))
}
